'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SubContent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SubContent(_ref) {
    var errors = _ref.errors,
        help = _ref.help;

    if (errors && errors.length) {
        return _react2.default.createElement(
            'div',
            { className: 'form__error' },
            errors.map(function (error, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    error
                );
            })
        );
    }

    if (help) {
        return _react2.default.createElement(
            'div',
            { className: 'form__help' },
            help
        );
    }

    return null;
}

SubContent.propTypes = {
    errors: _propTypes2.default.arrayOf(_propTypes2.default.node),
    help: _propTypes2.default.node
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@matyas/matyaskar-forked-react-ui/lib/Utils/SubContent.js
// module id = 26
// module chunks = 0